import { MainLayoutComponent } from './main-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { ToolbarModule } from 'app/modules/layout/components/toolbar/toolbar.module';
import { ContentModule } from '../components/content/content.module';
import { QuickPanelModule } from 'app/layout/components/quick-panel/quick-panel.module';


@NgModule({
    declarations: [
        MainLayoutComponent
    ],
    imports     : [
        RouterModule,
        FuseSharedModule,
        FuseSidebarModule,
        ContentModule,
        ToolbarModule,
        QuickPanelModule
    ],
    exports     : [
        MainLayoutComponent
        
    ]
})
export class MainLayoutModule
{
}